import styled, { css } from 'styled-components';
import { getSpacingToken, getToken } from '@optimus-web/common';
import { Swipeable, SwipeableProps } from '@optimus-web/helpers';

export interface Vertical {
    vertical?: boolean;
}

const getWidthOrHeight = ({ vertical }: Vertical): string => (vertical ? 'max-height: 100%;' : 'max-width: 100%;');

const SwipeableWithoutVerticalProp = <T,>({ vertical, ...other }: Vertical & T) => <Swipeable {...other} />;

export const SlideAnimatorSwipeableElement = styled<React.ComponentType<SwipeableProps & { showArrows: boolean }>>(
    SwipeableWithoutVerticalProp
)`
    ${({ showArrows }) =>
        showArrows &&
        css`
            display: flex;
            align-items: center;
            position: relative;
            width: 100%;
            ${SlideAnimatorWrapperElement} {
                width: 100%;
            }
        `}

    ${getWidthOrHeight}
`;

export const SlideAnimatorWrapperElement = styled.ol<Vertical>`
    ${getWidthOrHeight}
    display: flex;
    overflow: hidden;
    list-style: none;
    padding: ${getSpacingToken('0')};
    margin: ${getSpacingToken('0')};

    ${(props) => props.vertical && 'flex-direction: column;'}
`;

export const ScrollIndicatorElement = styled.div<{ show: boolean }>`
    display: flex;
    align-items: center;
    ${({ show }) => css`
        transition: ${show
            ? 'opacity 250ms ease, visibility 0s ease 0s'
            : 'opacity 250ms ease, visibility 0s ease 250ms'};
        opacity: ${show ? getToken('opacity1000') : getToken('opacity0')};
        visibility: ${show ? 'visible' : 'hidden'};
    `}
`;
